"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagGB = function FlagGB(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.07,7.07,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-114.94a7.06,7.06,0,0,0-7.06-7.06h-31.6L47.11-36.28V-122H-23.51v85.72L-154.34-122h-31.6a7.06,7.06,0,0,0-7.06,7.06v18.27L-80.75-23.13H-193V47.49H-80.75L-193,121V139.3a7.07,7.07,0,0,0,7.06,7.06h31.6L-23.51,60.64v85.72H47.11V60.64l130.83,85.72h31.6a7.07,7.07,0,0,0,7.06-7.06V121L104.35,47.49H216.6V-23.13H104.35L216.6-96.67Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-9H33V-122H-9.39V-9H-193V33.37H-9.39v113H33v-113H216.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-49.84,47.49l-143,92.8a7,7,0,0,0,6.86,6.07h9.73L-23.9,47.49Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M84.11,47.49H58.17l152.09,98.72a7,7,0,0,0,6.34-6.91v-5.81Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193-107.14l129.42,84h25.95l-151.26-98.18a7,7,0,0,0-4.11,6.37Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M73.05-23.13l143.31-93a7,7,0,0,0-6.82-5.85H199.42L47.11-23.13Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagGB;
exports["default"] = _default;